import axios from "axios";
import Swal from "sweetalert2";

/**
 * Return the status of the RMA portal, returns true if the portal is under maintenance.
 * If the status code can not be retrieved, it will return true.
 * @returns {boolean} - True if the portal is under maintenance, false otherwise.
 */
export async function getStatus() {
  const response = await axios
    .get("/")
    .then(response => !!response.data.status)
    .catch(e => true);

  return response;
}

export async function maintenanceInfo() {
  Swal.fire({
    title: "Maintenance",
    text:
      "The RMA portal is currently under maintenance, not all features may be available."
  });
}
